import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const ContactPersonEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    userName: z.string(),
    email: z.string()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
